import React from 'react';
import { Briefcase, Mail, Linkedin, Twitter, Calendar, MapPin, Award, Layers, Users } from 'lucide-react';
export const Portfolio = () => {
  return <div className="w-full bg-white min-h-screen" data-id="element-4298">
      {/* Hero Section */}
      <section className="pt-20 pb-16 border-b border-gray-200" data-id="element-4299">
        <div className="container mx-auto px-4" data-id="element-4300">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-4301">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-4302">
              <div className="w-64 h-64 border-2 border-gray-300 rounded-full overflow-hidden" data-id="element-4303">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sGA11gNJc7vxEwMehjwPFv/dreyyyy.jpg" alt="Andrew Igbineweka" className="w-full h-full object-cover grayscale" loading="eager" width="256" height="256" data-id="element-4304" />
              </div>
            </div>
            <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-4305">
              <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4" data-id="element-4306">
                Andrew Igbineweka
              </h1>
              <h2 className="text-2xl text-gray-600 mb-6" data-id="element-4307">
                Human Capital Development Professional
              </h2>
              <p className="text-gray-600 mb-6 max-w-2xl" data-id="element-4308">
                Passionate about connecting people to networks, ideas, and
                opportunities. Experienced in community building, strategic
                partnerships, and talent development.
              </p>
              <div className="flex flex-wrap gap-4 justify-center md:justify-start" data-id="element-4309">
                <a href="mailto:andrew@example.com" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4310">
                  <Mail size={16} className="text-gray-600" data-id="element-4311" />
                  <span data-id="element-4312">Contact</span>
                </a>
                <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4313">
                  <Linkedin size={16} className="text-gray-600" data-id="element-4314" />
                  <span data-id="element-4315">LinkedIn</span>
                </a>
                <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50" data-id="element-4316">
                  <Twitter size={16} className="text-gray-600" data-id="element-4317" />
                  <span data-id="element-4318">Twitter</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-4319">
        <div className="container mx-auto px-4" data-id="element-4320">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4321">
            About Me
          </h2>
          <div className="flex flex-col md:flex-row gap-12" data-id="element-4322">
            <div className="w-full md:w-2/3" data-id="element-4323">
              <p className="text-gray-600 mb-6" data-id="element-4324">
                I am a Human Capital Development Professional with expertise in
                community building, strategic partnerships, and talent
                development. My work focuses on connecting young professionals
                to networks, ideas, and opportunities worldwide.
              </p>
              <p className="text-gray-600 mb-6" data-id="element-4325">
                As the founder of The Networking Salon, I've built communities
                across multiple cities, creating platforms for meaningful
                connections and professional growth.
              </p>
              <p className="text-gray-600" data-id="element-4326">
                My approach combines strategic thinking with human-centered
                design, creating systems and experiences that help individuals
                and organizations thrive in today's rapidly evolving landscape.
              </p>
            </div>
            <div className="w-full md:w-1/3" data-id="element-4327">
              <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4328">
                <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-4329">
                  Details
                </h3>
                <ul className="space-y-4" data-id="element-4330">
                  <li className="flex items-center gap-3" data-id="element-4331">
                    <Calendar size={20} className="text-gray-500" data-id="element-4332" />
                    <div data-id="element-4333">
                      <p className="text-sm text-gray-500" data-id="element-4334">Experience</p>
                      <p className="text-gray-700" data-id="element-4335">7+ Years</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4336">
                    <MapPin size={20} className="text-gray-500" data-id="element-4337" />
                    <div data-id="element-4338">
                      <p className="text-sm text-gray-500" data-id="element-4339">Location</p>
                      <p className="text-gray-700" data-id="element-4340">Nigeria</p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4341">
                    <Award size={20} className="text-gray-500" data-id="element-4342" />
                    <div data-id="element-4343">
                      <p className="text-sm text-gray-500" data-id="element-4344">Education</p>
                      <p className="text-gray-700" data-id="element-4345">
                        MBA, University of Nigeria
                      </p>
                    </div>
                  </li>
                  <li className="flex items-center gap-3" data-id="element-4346">
                    <Layers size={20} className="text-gray-500" data-id="element-4347" />
                    <div data-id="element-4348">
                      <p className="text-sm text-gray-500" data-id="element-4349">Focus Areas</p>
                      <p className="text-gray-700" data-id="element-4350">
                        Community Building, Strategic Partnerships, Talent
                        Development
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Tools Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-4351">
        <div className="container mx-auto px-4" data-id="element-4352">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4353">
            Tools & Skills
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-4354">
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4355">
              <div className="flex items-center gap-3 mb-4" data-id="element-4356">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4357">
                  <div size={20} className="text-gray-600" data-id="element-4358" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4359">
                  Strategic Planning
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4360">
                <li className="flex items-center gap-2" data-id="element-4361">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4362"></div>
                  <span className="text-gray-600" data-id="element-4363">Stakeholder Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4364">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4365"></div>
                  <span className="text-gray-600" data-id="element-4366">SWOT Analysis</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4367">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4368"></div>
                  <span className="text-gray-600" data-id="element-4369">Project Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4370">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4371"></div>
                  <span className="text-gray-600" data-id="element-4372">Risk Assessment</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4373">
              <div className="flex items-center gap-3 mb-4" data-id="element-4374">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4375">
                  <Users size={20} className="text-gray-600" data-id="element-4376" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4377">
                  Community Building
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4378">
                <li className="flex items-center gap-2" data-id="element-4379">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4380"></div>
                  <span className="text-gray-600" data-id="element-4381">Event Planning</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4382">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4383"></div>
                  <span className="text-gray-600" data-id="element-4384">Member Engagement</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4385">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4386"></div>
                  <span className="text-gray-600" data-id="element-4387">Content Creation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4388">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4389"></div>
                  <span className="text-gray-600" data-id="element-4390">Relationship Management</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4391">
              <div className="flex items-center gap-3 mb-4" data-id="element-4392">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4393">
                  <Briefcase size={20} className="text-gray-600" data-id="element-4394" />
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4395">
                  Business Development
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4396">
                <li className="flex items-center gap-2" data-id="element-4397">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4398"></div>
                  <span className="text-gray-600" data-id="element-4399">Partnership Building</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4400">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4401"></div>
                  <span className="text-gray-600" data-id="element-4402">Negotiation</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4403">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4404"></div>
                  <span className="text-gray-600" data-id="element-4405">
                    Client Relationship Management
                  </span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4406">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4407"></div>
                  <span className="text-gray-600" data-id="element-4408">Revenue Strategy</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4409">
              <div className="flex items-center gap-3 mb-4" data-id="element-4410">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4411">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4412"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4413">
                  Digital Tools
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4414">
                <li className="flex items-center gap-2" data-id="element-4415">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4416"></div>
                  <span className="text-gray-600" data-id="element-4417">Microsoft Office Suite</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4418">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4419"></div>
                  <span className="text-gray-600" data-id="element-4420">Google Workspace</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4421">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4422"></div>
                  <span className="text-gray-600" data-id="element-4423">Canva</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4424">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4425"></div>
                  <span className="text-gray-600" data-id="element-4426">CRM Systems</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4427">
              <div className="flex items-center gap-3 mb-4" data-id="element-4428">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4429">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4430"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4431">
                  Communication
                </h3>
              </div>
              <ul className="space-y-2" data-id="element-4432">
                <li className="flex items-center gap-2" data-id="element-4433">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4434"></div>
                  <span className="text-gray-600" data-id="element-4435">Public Speaking</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4436">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4437"></div>
                  <span className="text-gray-600" data-id="element-4438">Content Writing</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4439">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4440"></div>
                  <span className="text-gray-600" data-id="element-4441">Presentation Design</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4442">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4443"></div>
                  <span className="text-gray-600" data-id="element-4444">Storytelling</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 hover:shadow-md transition-shadow" data-id="element-4445">
              <div className="flex items-center gap-3 mb-4" data-id="element-4446">
                <div className="w-10 h-10 flex items-center justify-center bg-gray-100 rounded-full" data-id="element-4447">
                  <div className="w-5 h-5 bg-gray-600 rounded-sm" data-id="element-4448"></div>
                </div>
                <h3 className="text-xl font-bold text-gray-800" data-id="element-4449">Leadership</h3>
              </div>
              <ul className="space-y-2" data-id="element-4450">
                <li className="flex items-center gap-2" data-id="element-4451">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4452"></div>
                  <span className="text-gray-600" data-id="element-4453">Team Management</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4454">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4455"></div>
                  <span className="text-gray-600" data-id="element-4456">Mentoring</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4457">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4458"></div>
                  <span className="text-gray-600" data-id="element-4459">Conflict Resolution</span>
                </li>
                <li className="flex items-center gap-2" data-id="element-4460">
                  <div className="w-2 h-2 bg-gray-400 rounded-full" data-id="element-4461"></div>
                  <span className="text-gray-600" data-id="element-4462">Decision Making</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Experience Section */}
      <section className="py-16 border-b border-gray-200 bg-gray-50" data-id="element-4463">
        <div className="container mx-auto px-4" data-id="element-4464">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4465">
            Professional Experience
          </h2>
          <div className="space-y-8" data-id="element-4466">
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4467">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4468">
                <div data-id="element-4469">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4470">
                    Founder & CEO
                  </h3>
                  <p className="text-gray-600" data-id="element-4471">The Networking Salon</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4472">2018 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4473">
                <li data-id="element-4474">
                  Founded and scaled a global community initiative connecting
                  young professionals across 25+ cities worldwide
                </li>
                <li data-id="element-4475">
                  Developed strategic partnerships with organizations to create
                  opportunities for community members
                </li>
                <li data-id="element-4476">
                  Designed and implemented community-building frameworks and
                  engagement strategies
                </li>
                <li data-id="element-4477">
                  Led a team of city leads and volunteers to execute the vision
                  in multiple locations
                </li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4478">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4479">
                <div data-id="element-4480">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4481">
                    Human Capital Development Consultant
                  </h3>
                  <p className="text-gray-600" data-id="element-4482">Various Organizations</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4483">2016 - Present</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4484">
                <li data-id="element-4485">
                  Provided strategic guidance on talent development and
                  organizational culture
                </li>
                <li data-id="element-4486">
                  Designed and facilitated leadership development programs and
                  workshops
                </li>
                <li data-id="element-4487">
                  Implemented community-building strategies for corporate
                  clients
                </li>
                <li data-id="element-4488">Advised on employee engagement and retention strategies</li>
              </ul>
            </div>
            <div className="border border-gray-300 rounded-lg p-6 bg-white" data-id="element-4489">
              <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-4490">
                <div data-id="element-4491">
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-4492">
                    Community Manager
                  </h3>
                  <p className="text-gray-600" data-id="element-4493">Tech Innovation Hub</p>
                </div>
                <p className="text-gray-500 mt-2 md:mt-0" data-id="element-4494">2015 - 2018</p>
              </div>
              <ul className="space-y-2 text-gray-600 list-disc pl-5" data-id="element-4495">
                <li data-id="element-4496">
                  Managed a community of tech entrepreneurs and innovators
                </li>
                <li data-id="element-4497">
                  Organized networking events, workshops, and skill-building
                  programs
                </li>
                <li data-id="element-4498">
                  Facilitated connections between community members and
                  potential investors/partners
                </li>
                <li data-id="element-4499">
                  Created content and communications strategies for community
                  engagement
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* Brands Section */}
      <section className="py-16 border-b border-gray-200" data-id="element-4500">
        <div className="container mx-auto px-4" data-id="element-4501">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4502">
            Brands I've Worked With
          </h2>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8" data-id="element-4503">
            {/* Brand logos would go here - using placeholders for wireframe */}
            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(item => <div key={item} className="flex items-center justify-center p-4 border border-gray-300 rounded-lg h-24" data-id="element-4504">
                <div className="w-16 h-8 bg-gray-300 rounded-md" data-id="element-4505"></div>
              </div>)}
          </div>
          <p className="text-center text-gray-500 mt-8" data-id="element-4506">
            Note: These are placeholder blocks for brand logos you've worked
            with. You'll need to add actual logos of brands from your
            experience.
          </p>
        </div>
      </section>
      {/* Contact Section */}
      <section className="py-16" data-id="element-4507">
        <div className="container mx-auto px-4" data-id="element-4508">
          <h2 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-4509">
            Get In Touch
          </h2>
          <div className="max-w-3xl mx-auto" data-id="element-4510">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-4511">
              <a href="mailto:andrew@example.com" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4512">
                <Mail size={32} className="text-gray-600 mb-3" data-id="element-4513" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4514">Email</h3>
                <p className="text-gray-600 text-center" data-id="element-4515">andrew@example.com</p>
              </a>
              <a href="https://linkedin.com/in/andrewigbineweka" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4516">
                <Linkedin size={32} className="text-gray-600 mb-3" data-id="element-4517" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4518">
                  LinkedIn
                </h3>
                <p className="text-gray-600 text-center" data-id="element-4519">andrewigbineweka</p>
              </a>
              <a href="https://twitter.com/example" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center p-6 border border-gray-300 rounded-lg hover:shadow-md transition-shadow" data-id="element-4520">
                <Twitter size={32} className="text-gray-600 mb-3" data-id="element-4521" />
                <h3 className="text-lg font-bold text-gray-800 mb-1" data-id="element-4522">
                  Twitter
                </h3>
                <p className="text-gray-600 text-center" data-id="element-4523">@andrewigbineweka</p>
              </a>
            </div>
            <div className="text-center" data-id="element-4524">
              <p className="text-gray-600 mb-6" data-id="element-4525">
                Interested in working together? I'm always open to discussing
                new projects, opportunities and partnerships.
              </p>
              <a href="mailto:andrew@example.com" className="inline-flex items-center gap-2 px-6 py-3 border-2 border-gray-800 rounded-md hover:bg-gray-800 hover:text-white transition-colors" data-id="element-4526">
                <Mail size={18} data-id="element-4527" />
                <span className="font-bold" data-id="element-4528">Send Me a Message</span>
              </a>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="py-8 border-t border-gray-200 bg-gray-50" data-id="element-4529">
        <div className="container mx-auto px-4 text-center" data-id="element-4530">
          <p className="text-gray-600" data-id="element-4531">
            &copy; {new Date().getFullYear()} Andrew Igbineweka. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>;
};